function ContactPage() {
  return (
    <>
      <header className="hero legal-hero">
        <div>
          <p className="eyebrow">Contact Us</p>
          <h1>Feedback, Ideas, Partnerships</h1>
          <p className="sub">
            Have feature ideas, content feedback, or partnership requests? Reach out using the channels below. Please avoid
            sharing sensitive or personal information.
          </p>
          <a className="primary" href="#/">
            Back to Home
          </a>
        </div>
      </header>
      <main className="content">
        <section className="panel legal">
          <div className="panel-head">
            <div>
              <p className="eyebrow">Contact Channels</p>
              <h2>Stay Connected</h2>
            </div>
          </div>
          <div className="legal-block">
            <h3>Email</h3>
            <ul>
              <li>hoaquynh72062@gmail.com (sample, replace with your real mailbox)</li>
            </ul>
          </div>
          <div className="legal-block">
            <h3>Feedback Guidelines</h3>
            <ul>
              <li>Describe the issue or scenario; attach screenshots when helpful.</li>
              <li>Do not submit personal sensitive data (ID cards, bank info, etc.).</li>
              <li>Content must follow local laws; avoid illegal or inappropriate info.</li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default ContactPage;

